import { commonTypes } from '../common';

export const initialState = {
  poitSelected: null,
  poptSelected: null,
  poshtSelected: null,
};

const ApisNeedsPOTsReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_POSHT_SELECTED: {
      const { poshtSelected } = action.payload;
      return {
        ...state,
        poshtSelected,
      };
    }
    case commonTypes.SET_POIT_SELECTED: {
      const { poitSelected } = action.payload;
      return {
        ...state,
        poitSelected: poitSelected.id,
      };
    }
    case commonTypes.SET_POPT_SELECTED: {
      const { poptSelected } = action.payload;
      return {
        ...state,
        poptSelected: poptSelected.id,
      };
    }
    default:
      return null;
  }
};

export const actions = {
};

export default ApisNeedsPOTsReducer;
